import { CATEGORY_MAIN } from 'app/const/categories';
import { NO_FAT_FILTER, ZAPAS_TAG_ID } from 'app/utils/filters';
import { useReactiveVar } from '@apollo/client';
import { selectedPeriodVar } from 'app/apollo/reaction';
import { useDishesSelection } from './useDishesSelection';

import {
    allDishes as kidsConfigDishes,
} from '../../../../../landings/promo-checkout/src/pages/kids/build-config';

// dishes which should be always shows
const hitsConstantlyShownDishes = ['25', '24', '3843'];
const kidsDishesIds = ['4134', '4132', '4130', '4133', '3992', '2891', '3295', '991'];

export const useMenuSelectionsDishes = () => {
    const period = useReactiveVar(selectedPeriodVar);
    const greenDishes = useDishesSelection({
        period,
        categoryId: CATEGORY_MAIN,
        tags: [NO_FAT_FILTER],
    })?.filter((d) => d.id !== '4607');

    const hitsDishes = useDishesSelection({
        period,
        configDishes: ['1924', '25', '24', '3843'],
    });

    const hitsDishesToFilterInItsCategory = hitsDishes.filter((d) => !hitsConstantlyShownDishes.includes(d.id));

    const nzDishes = useDishesSelection({
        period,
        categoryId: CATEGORY_MAIN,
        tags: [ZAPAS_TAG_ID],
    }).filter((d) => !d.tags.some((t) => t.id === '1220'));

    const kidsDishes = useDishesSelection({
        period,
        configDishes: kidsDishesIds.filter((d) => d !== '3093'),
    });

    const firstTimeDishes = useDishesSelection({
        period,
        configDishes: ['1378', '4809', '4908', '2241', '2929'],
    });

    const delicaciesDishes = useDishesSelection({
        period,
        configDishes: ['3386', '172', '364', '5337'],
    });

    const readyToEatDishes = useDishesSelection({
        period,
        configDishes: ['5523', '5524', '5525', '5526', '5527'],
    });

    return {
        collections: {
            greenDishes,
            hitsDishes,
            nzDishes,
            kidsDishes,
            firstTimeDishes,
            delicaciesDishes,
            readyToEatDishes,
        },
        // dishes, which are needed to be filtered in main menu.
        // the exceptions are some of hits dishes, and all the selections which's UI part is a slider.
        allDishes: [...greenDishes, ...hitsDishesToFilterInItsCategory, ...nzDishes, ...kidsDishes, ...firstTimeDishes, readyToEatDishes],
    };
};
